/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Food and other drinks contribute a meaningful share of your fluid intake, so you don't need to hit the full number from plain water alone.`)
};

const es_water_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. La comida y otras bebidas aportan una parte importante de tu ingesta de líquidos, así que no necesitas alcanzar la cifra completa solo con agua.`)
};

const de_water_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Nahrung und andere Getränke tragen einen erheblichen Teil zu deiner Flüssigkeitszufuhr bei, sodass du den vollen Wert nicht allein durch reines Wasser erreichen musst.`)
};

const nl_water_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Voeding en andere dranken leveren een aanzienlijk deel van je vochtinname, dus je hoeft het volledige getal niet alleen met puur water te halen.`)
};

const fr_water_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. La nourriture et les autres boissons contribuent de manière significative à votre apport hydrique, vous n'avez donc pas besoin d'atteindre le chiffre complet avec de l'eau pure seulement.`)
};

const it_water_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Cibo e altre bevande contribuiscono in modo significativo all'apporto di liquidi, quindi non serve raggiungere l'intero valore solo con acqua pura.`)
};

const pt_br2_water_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Alimentos e outras bebidas contribuem com uma parte relevante da sua ingestão de líquidos, então você não precisa atingir o número total só com água pura.`)
};

const pt_water_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Os alimentos e outras bebidas contribuem com uma parte significativa da ingestão de fluidos, por isso não precisa de atingir o número total apenas com água.`)
};

const ja_water_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。食事や他の飲み物も水分摂取量のかなりの割合を占めるため、水だけで全量を摂る必要はありません。`)
};

const zh_water_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`算的。食物和其他饮品也会贡献相当一部分水分摄入，因此不需要仅靠白水就达到全部数值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_faq_a3", locale)
	if (locale === "en") return en_water_faq_a3(inputs)
	if (locale === "es") return es_water_faq_a3(inputs)
	if (locale === "de") return de_water_faq_a3(inputs)
	if (locale === "nl") return nl_water_faq_a3(inputs)
	if (locale === "fr") return fr_water_faq_a3(inputs)
	if (locale === "it") return it_water_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_water_faq_a3(inputs)
	if (locale === "pt") return pt_water_faq_a3(inputs)
	if (locale === "ja") return ja_water_faq_a3(inputs)
	return zh_water_faq_a3(inputs)
};